import { Routes } from '@angular/router';

import { AuthGuard } from '../login/auth/auth.guard';
import { OnboardingGuard } from '../login/auth/onboarding.guard';
import { PermissionGuard } from '../login/auth/permission.guard';
import { LandingGuard, MarsOnlyGuard } from '../login/auth/mars-only.guard';
import { KITCHEN_URL, RELOGIN_URL, WAITER_URL } from '../login/landing';
import { PERMISSION } from '../login/permissions';

/** Route path of a screen url (`/mars/waiter` → `mars/waiter`). */
const pathOf = (url: string) => url.slice(1);

/**
 * Waiter and kitchen screens (and their "Tekrar giriş" page): full screen,
 * outside the dashboard layout. The old `/service/*` urls (phone and TV
 * bookmarks) redirect to the same screen; the query (`?mode=view`) stays.
 */
export const MARS_ROUTES: Routes = [
  {
    path: pathOf(WAITER_URL),
    loadComponent: () => import('./shell/mars-shell.component').then((m) => m.MarsShellComponent),
    canActivate: [AuthGuard, PermissionGuard],
    data: { title: 'Waiter', screen: 'waiter', requiresPermission: PERMISSION.MARS_ORDER },
  },
  {
    path: pathOf(KITCHEN_URL),
    loadComponent: () => import('./shell/mars-shell.component').then((m) => m.MarsShellComponent),
    canActivate: [AuthGuard, PermissionGuard],
    data: { title: 'Kitchen', screen: 'kitchen', requiresPermission: PERMISSION.MARS_KITCHEN },
  },
  {
    // Where a waiter or kitchen screen lands when its session ended; no session needed.
    path: pathOf(RELOGIN_URL),
    loadComponent: () => import('./relogin/relogin.component').then((m) => m.ReloginComponent),
    data: { title: 'Sign in again' },
  },
  // Relative redirects: an absolute one drops the query (measured, Angular 17).
  { path: 'service/waiter', redirectTo: pathOf(WAITER_URL) },
  { path: 'service/kitchen', redirectTo: pathOf(KITCHEN_URL) },
  { path: 'service/relogin', redirectTo: pathOf(RELOGIN_URL) },
];

/**
 * Guards of the dashboard layout route. Waiter and kitchen sessions are
 * turned away to their own screen before onboarding is asked about.
 */
export const DASHBOARD_LAYOUT_GUARDS = [AuthGuard, MarsOnlyGuard, OnboardingGuard];

/** Unknown urls: where the session starts (dashboard or waiter / kitchen screen). */
export const LANDING_ROUTE = { path: '**', canActivate: [LandingGuard], children: [] };
